import {field} from "../../../../generic/tables";
import React from "react";
import {showOrderDynamicRow} from "./utils";
import {sailingExperienceFromSlotToArrival} from "sv-common/functions/formatters";
import {t} from "i18next";


export const getPracticeSet = () => ([
    field(
        t('common.productOrderList.name'),
        false,
        "client_id.first_name",
        res => showOrderDynamicRow('first_name', res, true),
        'pt-2 pb-2'),
    field(t('common.productOrderList.lastname'), false, "client_id.last_name",
        res => showOrderDynamicRow('last_name', res), 'pt-2 pb-2'),
    field(t('common.productOrderList.phone'), false, "client_id.phone",
        res => {
            if (res.contact_phone && res.paid_for_ids.length) {
              res.paid_for_ids[0].phone = res.contact_phone;
            }
            return showOrderDynamicRow('phone', res)
        }, 'pt-2 pb-2'),
    field(t('common.productOrderList.count'), false, "paid_for_length"),
    field(t('common.productOrderList.comment'), false, "comment", res =>
        <>{res?.comment?.match(/.{1,50}/g)?.map(line => <div>{line}</div>)}</>
    ),
    field(t('common.productOrderList.sailingExperience'), false, "client_id.sailing_experience",
        res => showOrderDynamicRow('sailing_experience', { ...res, paid_for_ids: res.paid_for_ids.map(i => ({ ...i, sailing_experience: sailingExperienceFromSlotToArrival(i.sailing_experience) })) })),
    field(t('common.productOrderList.email'), false, "client_id.email",
        res => showOrderDynamicRow('email', res), 'pt-2 pb-2'),
])